<template>
  <v-row>
    <v-col
      sm="1"
      lg="2"
      class="hidden-xs-only"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            color="primary"
            v-bind="attrs" 
            v-on="on" 
            @click="regresar"
          >
            <v-icon>
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>
    <v-col 
      cols="12" 
      sm="10" 
      lg="8"
    >
      <DetailCard
        title="Detalles Competencia"
        :loading="cardLoading"
      >
        <v-row justify="center">
          <v-col
            v-for="(item, index) in competencia" 
            :key="index"
            cols="12" 
            sm="10" 
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              {{ item.label }}
            </p>
            <template v-if="item.value != null">
              <p class="text-subtitle-1">
                {{ item.value }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrado
              </p>
            </template>
          </v-col>
        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>

<script>
import DetailCard from '../../../components/admin/DetailCard.vue';

export default {
  data: () => ({
    cardLoading: true
  }),

  components: {
    DetailCard
  },

  mounted() {
    this.$store.dispatch("detallesCompetencia", this.$route.params.id_competencia)
    setTimeout(() => {
      this.cardLoading = false
    }, 1000)
  },

  computed: {
    competencia() {
      const detalles = this.$store.getters.obtenerCompetencia;
      const competencia = [
        {
          label:  "Competencia",
          value:  detalles.competencia
        },

        {
          label:  "Descripción",
          value:  detalles.descripcion
        },

        {
          label:  "Fecha Inicio",
          value:  detalles.fecha_inicio
        },

        {
          label:  "Fecha Fin",
          value:  detalles.fecha_fin
        },

        {
          label:  "Lugar",
          value:  detalles.lugar
        },

        {
          label:  "Dirección",
          value:  detalles.direccion
        },

        {
          label:  "Regional",
          value:  detalles.regional
        },

        {
          label:  "Centro de Formación",
          value:  detalles.centro_formacion
        },
      ];

      return competencia;
    },
  },

  methods: {
    regresar() {
      this.$router.back()
    }
  }
};
</script>